'use client';
import React, { useEffect } from 'react';

export const GoogleScriptLoader = () => {
  useEffect(() => {
    if (
      document.querySelector('script[src*="accounts.google.com/gsi/client"]')
    ) {
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return null;
};
